import {
  Button,
  Checkbox,
  createTheme,
  Drawer,
  Fieldset,
  Input,
  MantineColorsTuple,
  Menu,
  Modal,
  Radio,
  Select,
  Switch,
  Table,
} from '@mantine/core';
import './lightTheme.scss';
import { DatePickerInput, DateTimePicker } from '@mantine/dates';
import { IconChevronDown } from '@tabler/icons-react';

// built using https://mantine.dev/colors-generator/?color=52b0ae
const shareHeritageColors: MantineColorsTuple = [
  '#edfbfc',
  '#ddf5f7',
  '#b5ebef',
  '#8be1e8',
  '#6dd8e1',
  '#5cd3dd',
  '#51d1dc',
  '#42b8c3',
  '#34a4ae',
  '#0E5B61',
];

export const messagingChannelsColor = {
  blueMessenger: '#605CFF',
  greenWhatsApp: '#41C452',
  blueSignal: '#3A76F0',
  greenSMS: '#40BA0C',
  blueEmail: '#1E4383',
};

const primaryMain = '#0E5B61';
const primaryOpacityMain = '#0C7D8429';
const primaryDark = '#114B50';
const divider = '#022c310d';
export const yellowFavorite = '#E9C70AFF';
export const secondaryMain = '#73999d';

export const lightTheme = createTheme({
  primaryColor: 'shareHeritage',
  primaryShade: 9,
  colors: { shareHeritage: shareHeritageColors },
  components: {
    InputWrapper: {
      classNames: {
        description: 'input-label',
      },
    },
    Input: Input.extend({
      styles: (_theme, params) => ({
        input: {
          ...(params.variant !== 'unstyled' && {
            border: '1px solid rgba(34, 48, 62, 0.22)',
            borderRadius: '6px',
            height: 48,
          }),
        },
      }),
    }),
    Radio: Radio.extend({
      styles: {
        radio: {
          cursor: 'pointer',
        },
      },
      vars: () => ({
        root: {
          '--radio-color': primaryMain,
        },
      }),
    }),
    Drawer: Drawer.extend({
      classNames: {
        title: 'text-h4',
      },
      styles: {
        header: {
          borderBottom: `1px solid ${divider}`,
        },
        body: {
          padding: 24,
        },
      },
    }),
    Fieldset: Fieldset.extend({
      styles: {
        root: {
          borderRadius: '8px',
        },
      },
    }),
    Button: Button.extend({
      vars: () => ({
        root: {
          '--mantine-color-shareHeritage-light': primaryOpacityMain,
          '--mantine-color-shareHeritage-light-color': primaryDark,
          '--mantine-primary-color-filled': primaryMain,
          '--button-hover': primaryDark,
          '--mantine-primary-color-filled-hover': primaryDark,
        },
      }),
      defaultProps: {
        radius: 500,
      },
      classNames: {
        label: 'btn-medium',
      },
      styles: {
        root: {
          border: 'none',
        },
      },
    }),
    DateTimePicker: DateTimePicker.extend({
      defaultProps: {
        dropdownType: 'modal',
      },
    }),
    DatePickerInput: DatePickerInput.extend({
      defaultProps: {
        dropdownType: 'modal',
      },
    }),
    Modal: Modal.extend({
      styles: {
        inner: {
          zIndex: 300,
        },
        overlay: {
          zIndex: 299,
        },
        content: {
          borderRadius: 8,
        },
        header: {
          padding: 24,
        },
        body: {
          padding: '0px 24px 24px 24px',
        },
      },
    }),
    Menu: Menu.extend({
      styles: {
        dropdown: {
          boxShadow: '0 .25rem .75rem 0 rgba(34,48,62,.14)',
          paddingTop: 8,
          paddingBottom: 8,
          paddingLeft: 0,
          paddingRight: 0,
          borderRadius: '0.375rem',
        },
        itemLabel: {
          display: 'flex',
          flexDirection: 'row',
        },
        item: {
          borderRadius: 0,
        },
      },
    }),
    Checkbox: Checkbox.extend({
      styles: {
        input: {
          cursor: 'pointer',
        },
      },
      defaultProps: {
        color: primaryMain,
      },
    }),
    Switch: Switch.extend({
      styles: {
        track: {
          cursor: 'pointer',
        },
      },
      defaultProps: {
        color: primaryMain,
      },
      vars: () => ({
        root: {
          cursor: 'pointer',
          '--switch-color': primaryMain,
        },
      }),
    }),
    Select: Select.extend({
      defaultProps: {
        rightSection: <IconChevronDown size={20} />,
        rightSectionPointerEvents: 'none',
        comboboxProps: {
          offset: 8,
          transitionProps: {
            transition: 'scale-y',
          },
          shadow: 'md',
        },
      },
    }),
    Table: Table.extend({
      styles: {
        table: {
          borderSpacing: '0 8px',
          borderCollapse: 'separate',
        },
        th: {
          borderBottom: 'none',
        },
      },
    }),
  },
});
